module.exports = __webpack_public_path__ + "img/notification-bell-mobile-ru.f881be82.jpg";